import { render, staticRenderFns } from "./CorrectionPanel.vue?vue&type=template&id=db36adb2&scoped=true"
import script from "./CorrectionPanel.vue?vue&type=script&lang=js"
export * from "./CorrectionPanel.vue?vue&type=script&lang=js"
import style0 from "./CorrectionPanel.vue?vue&type=style&index=0&id=db36adb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db36adb2",
  null
  
)

export default component.exports